import React from "react";
import "../../Styles/yellowcalf.css/Vehicle_Expense_Report.css";

function Vehicle_Expense_Report() {
  return (
    <div className="vehicle-expense-report-container" style={{ paddingTop: "25px" }}>
      <div className="vehicle-expense-report-header-section">
        <div className="vehicle-expense-report-header-box">
          <h3 className="vehicle-expense-report-header-title">Vehicle Expense Report</h3>

          <div className="vehicle-expense-report-export-section">
            <button className="vehicle-expense-report-export-button">
              Export <i className="fa fa-angle-down"></i>
            </button>

            <ul className="vehicle-expense-report-export-list">
              <li><a href="#">Save as PDF</a></li> 
            </ul>
          </div>
        </div>
      </div>

      <div className="vehicle-expense-report-filter-section">
        <div className="vehicle-expense-report-filter-row">
          <div className="vehicle-expense-report-filter-item">
            <select id="student_id" className="vehicle-expense-report-select">
              <option value="">All Vehicle</option>
              <option value="189">ssds - hjh45</option>
              <option value="207">hebu - 78787878</option>
              <option value="211">siva - 34567889</option>
              <option value="186">Kaleem - 456</option>
              <option value="222">testing - 34567889</option>
              <option value="101">Mahesh - 546452367</option>
              <option value="224">ritu - 607046</option>
            </select>
          </div>

          <div className="vehicle-expense-report-filter-item">
            <input
              type="date"
              id="startdate"
              className="vehicle-expense-report-date-input"
              placeholder="Start Date"
            />
          </div>

          <div className="vehicle-expense-report-filter-item">
            <input
              type="date"
              id="enddate"
              className="vehicle-expense-report-date-input"
              placeholder="End Date"
            />
          </div>

          <div className="vehicle-expense-report-filter-item">
            <button type="submit" className="vehicle-expense-report-btn vehicle-expense-report-btn-search">
              Search
            </button>
            <button type="reset" className="vehicle-expense-report-btn vehicle-expense-report-btn-clear">
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Vehicle_Expense_Report;
